import type { RefineThemedLayoutProps } from "@refinedev/antd";
import { Layout as AntdLayout, Grid } from "antd";
import React from "react";
import { ThemedHeader } from "./header";
import "./layout.css";

export const ThemedLayout: React.FC<RefineThemedLayoutProps> = ({
  children,
  Title,
  Footer,
  OffLayoutArea,
}) => {
  const breakpoint = Grid.useBreakpoint();

  return (
    <AntdLayout
      className="themed-layout-blur"
      style={{ minHeight: "100vh", background: "#00294A" }}
    >
      <ThemedHeader />
      <AntdLayout.Content style={{ minHeight: "calc(100vh - 54px)" }}>
        <div
          style={{
            height: "100%",
          }}
        >
          {children}
        </div>
        {OffLayoutArea && <OffLayoutArea />}
      </AntdLayout.Content>
      {Footer && <Footer />}
    </AntdLayout>
  );
};
